import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";

export const FiltroMulti = ({ k, label, opciones, valor = [], onChange }) => {
  const [open, setOpen] = useState(false);
  const toggle = (o) => onChange(valor.includes(o) ? valor.filter((x) => x !== o) : [...valor, o]);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button data-testid={`exp-filtro-${k}`}
          className={`inline-flex items-center gap-1 rounded-full border px-3 py-1.5 text-xs font-semibold transition-colors ${valor.length ? "border-[#13315C] bg-[#13315C] text-white" : "border-[#E2DDD5] bg-white text-[#5C5850] hover:bg-[#F2F0EC]"}`}>
          {label}{valor.length > 0 && ` · ${valor.length}`}<ChevronDown size={12} />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-2" align="start">
        <div className="max-h-64 space-y-0.5 overflow-auto">
          {opciones.map((o) => (
            <label key={o} className="flex cursor-pointer items-center gap-2 rounded-lg px-2 py-1.5 text-xs hover:bg-[#F2F0EC]" data-testid={`exp-op-${k}-${o}`}>
              <input type="checkbox" checked={valor.includes(o)} onChange={() => toggle(o)} className="accent-[#13315C]" />{o}
            </label>))}
        </div>
        {valor.length > 0 && <button className="mt-2 w-full rounded-lg border border-[#E2DDD5] py-1 text-xs" onClick={() => onChange([])} data-testid={`exp-limpiar-${k}`}>Limpiar</button>}
      </PopoverContent>
    </Popover>
  );
};
